import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import { ProductCollectionModel } from "@insite/client-framework/Types/ApiModels";
import { DesignerProductsDataState } from "@tSurya/Store/Data/SurDesignerProductsDataState";
import { Draft } from "immer";

const initialState: DesignerProductsDataState = {
    isLoading: false,
    designerProducts: [],
    searchparameter: [],
    pagination: null,
};

const reducer = {
    "Custom/DesignerProductList/BeginLoad": (draft: Draft<DesignerProductsDataState>) => {
        draft.isLoading = true;
    },
    "Custom/DesignerProductList/CompleteLoadStore": (
        draft: Draft<DesignerProductsDataState>,
        action: { searchparameter: DesignerProductsDataState },
    ) => {
        draft.searchparameter = action.searchparameter;
    },
    "Custom/DesignerProductList/CompleteLoad": (
        draft: Draft<DesignerProductsDataState>,
        action: {
            result: ProductCollectionModel;
        },
    ) => {
        draft.designerProducts = action.result.products;
        draft.pagination = action.result.pagination;
        draft.isLoading = false;
    }
};
export default createTypedReducerWithImmer(initialState, reducer);
